import { renderDivider_unstable } from '@fluentui/react-divider';

/**
 * Renders the final JSX of the Divider component, given the state.
 */
export const renderDivider = renderDivider_unstable;
